export default {
    print(params) {
        const page = window.open('', Math.random())

        page.document.write(`
            <head>
                <title>Senha</title>

                <style>
                    .container {
                        align-items: center;
                        display: flex;
                        justify-content: center;
                        width: 100%;
                    }
                    .content {
                        border: 1px solid #000000;
                        display: flex;
                        flex-direction: column;
                        width: 90%;
                    }
                    .title {
                        font-size: 2vw;
                        text-align: center;
                    }
                    .password {
                        align-items: center;
                        display: flex;
                        flex: 1;
                        font-size: 4vw;
                        justify-content: center;
                        text-align: center;
                        text-transform: uppercase;
                    }
            
                    @media print {
                        .title {
                            font-size: 3vw !important;
                        }
                        .password {
                            font-size: 10vw !important;
                        }
                    }
                </style>
            </head>

            <body>
                <div class="container">
                    <div class="content">
                        <p class="title">${params.infraestrutura} - ${params.setor}</p>
                        
                        <p class="password">${params.senha}</p>

                        <p class="title">
                            <span><strong>Data:</strong> ${params.data}</span>
                            <span><strong>Hora:</strong> ${params.hora}</span>
                        </p>

                        <p class="title">
                            Secretaria Municipal de Saúde - ${params.cliente}
                        </p>
                    </div>
                </div>
            </body>
        `)

        page.print()
        page.close()
    }
}